import * as signalR from '@microsoft/signalr';
import auth from '@it-enterprise/jwtauthentication';

function IiotDataClient(deviceId) {
  const sensorsHandlers = new Map();

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${window.myConfig.GrapgQlUrl}data-chat-hub`, {
      accessTokenFactory: async () => {
        return await auth.getToken();
      },
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .build();

  async function start() {
    try {
      await connection.start();
      console.log('SignalR Connected.');
    } catch (err) {
      console.log(err);
      setTimeout(start, 5000);
    }
  }

  connection.on('UpdateSensorValue', (sensorId, value) => {
    const handlers = sensorsHandlers.get(sensorId) ?? [];
    handlers.forEach((fn) => fn(value));
  });

  function closeConnect() {
    sensorsHandlers.clear();
    connection.invoke('UnsubscribeFromDevise', deviceId);
    connection.connectionClosed();
  }

  function subscribeToSensor(sensorId, cb) {
    const handlers = sensorsHandlers.get(sensorId) ?? [];
    sensorsHandlers.set(sensorId, [...handlers, cb]);
  }

  function unsubscribeFromSensor(sensorId) {
    sensorsHandlers.delete(sensorId);
  }

  start().then(() => {
    connection.invoke('SubscribeToDevise', deviceId);
  });

  return {
    closeConnect,
    subscribeToSensor,
    unsubscribeFromSensor,
  };
}

export default IiotDataClient;
